export enum SongSortMode {
  NONE = 'none',
  TITLE = 'title',
  GROUP = 'group',
  OTHER = 'other'
}
